// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'components.confirmDialog.wait': 'Aguarde…',
  },
  en: {
    'components.confirmDialog.wait': 'Please wait…',
  },
  es: {
    'components.confirmDialog.wait': 'Espere…',
  },
}
